import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import HintFactory from '../../../../components/Hint/HintFactory';

/**
 * @deprecated
 * Временный компонент (не использовать!!!)
 */

// TODO: Чтобы убрать надо перенести компонент (HotelOfferCell) из lt-components
// и обернуть его уже в сверстаный кастомный Bubble
const IncludedServicesHint = ({ isMobile }) => {
  const { t } = useTranslation();
  return (
    <HintFactory
      autoPosition={isMobile}
      events
      attribute="data-hint-included"
      onRenderContent={() => (
        // TODO: унифицировать хинты
        <div className="react-hint__content">
          <Container>
            <p>{t('hotel.IncludedServices.services')}</p>
          </Container>
        </div>
      )}
      isMobile={isMobile}
    />
  );
};

const Container = styled.div`
  margin: 0 auto;
  width: ${(props) => (props.isMobile ? '260px' : '241px')};
  font-size: 12px;
`;

export default IncludedServicesHint;
